export default __webpack_public_path__ + "media/color/nexo-0b1c4fbb.svg";